module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/ce5c9bf307add3fd442cca19330b4fcf.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Legend/Legend1.svg
// module id = +zM/
// module chunks = 1